import { render } from "./Sidebar.vue?vue&type=template&id=443a6fc2&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=443a6fc2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443a6fc2"]])

export default __exports__